import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to the top on every route change.
 *
 * The app's scroll container is actually `#root` (index.css sets height:100%
 * + overflow:auto on html/body/#root), so scrolling only `window` did nothing.
 * We reset every plausible scroll container to be safe, and use a layout effect
 * so it happens before the browser paints the new page (no visible jump).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const targets = [
      document.getElementById('root'),
      document.documentElement,
      document.body,
      document.querySelector('main'),
    ];
    targets.forEach((el) => {
      if (el) el.scrollTop = 0;
    });
    // Also reset the window itself (harmless if it isn't the scroller).
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
